<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
  viewBox="0 0 750 750" style="width: 750px;" xml:space="preserve">
  <style type="text/css">
    .st0{fill:url(#gradiente_00000110459290505272084120000010631885783837002368_);}
    .st1{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}
    .st2{fill:none;}
    .st3{fill:#CC2336;stroke:#FFFFFF;stroke-miterlimit:10;}
    .st4{fill:#FFFFFF;}
    .st5{font-family:'AlegreyaSans-Medium';}
    .st6{font-size:9.7483px;}
    .st7{font-family:"AlegreyaSans-ExtraBold";}
    .st8{font-size:29.245px;}
    .st9{font-size:25.9956px;}
    .st10{font-size:27.8042px;}
  </style>
  <linearGradient id="gradiente_00000155137058616494866240000013729859265513521575_" gradientUnits="userSpaceOnUse" x1="368.0881" y1="216.9" x2="368.0881" y2="932.3745" gradientTransform="matrix(1 0 0 1 0 -184)">
    <stop  offset="0" style="stop-color:#80BDE0"/>
    <stop  offset="1" style="stop-color:#0066CC"/>
  </linearGradient>
<path id="gradiente" style="fill:url(#gradiente_00000155137058616494866240000013729859265513521575_);" d="M447.1,356.7
	c1.1,3.1,41.4,33.4,46.2,40.3c4.8,6.9,19.7,14.9,26,14.9c6.4,0,26.5-2.7,28.2-2.7 M439.7,352.5c0,0-21.2-3.7-27.1-5.9
	c-5.8-2.1-21.7-11.1-34.5-15.4c-12.7-4.2-44.6-3.7-48.3-3.2c-2.6,0.4-20.4,0.2-30.8,0.1l-1.3,0.6c-4.1,2-7.9,4.4-11.5,7.3
	c-5.1,4.5-23.4,8.2-25.5,9.3c-11.1,5.7-21.7,12.2-31.9,19.4c-16.2,11.4-30.8,21.2-40.3,30c-9.6,8.8-0.8,7.7-3.2,10.6
	s-7.7-0.8-11.7,2.7c-4,3.4-10.4,10.9-14.9,14.6s-31.1,35-40.1,43.8s-39.6,43.5-43,48.3c-3.4,4.8-4.5,6.3-0.3,8.8
	c4.2,2.4,20.2-2.1,22.8-5c2.7-2.9,8.2-8.7,17.5-4c9.3,4.8,19.9,9,24.7,15.9s18.4,21,21.8,26.6c3.4,5.6,4.5,13,7.2,16.2
	c2.6,3.2,13,2.7,14.3-3.7s2.1-13,7.2-9.8c5,3.2,8.2,8.8,16.7,17s7.9,8.2,17.5,12.5s10.4,1.6,16.2,6.9c5.9,5.3,16.7,8.5,19.1,9.6
	s2.7-0.3,10.1,9.6s22.3,13.5,22.3,13.5s6.1,5.8,11.4,11.1c5.4,5.3,11.7,11.1,11.7,15.7c0.3,5.4,3.2,10.3,7.7,13.3
	c4.3,2.1,13.8,3.2,16.4,6.4c2.7,3.2,9.1,9.6,5.9,14.1s-10.1,8.5-12.2,11.2s-7.4,2.4-10.1,8.5s-4,7.9-2.7,18c0.9,6.8-0.8,18.4,8.2,21
	c8.9,2.6,20.4-14,26.7-18.9c4-3.2,8.8-3.9,12.4-7.6c8.8-9,14.1-23.7,18-35.5c2.9-8.6,5-18.1,11.4-24.6c3.9-3.3,8-6.4,12.3-9.2
	c7.6-5.9,9.6-15.6,16.7-21c7.8-5.6,15.9-10.6,24.4-14.9c11.7-6.4,38.5-28.7,43-36.4s39.8-71.2,48.6-88.4c2.3-4.3,5-8.5,7.9-12.4
	c0.6-0.8,1.1-1.6,1.7-2.4c1.6-2,3.2-4.2,4.9-6.3c-2.2-4.5-3.7-7.4-4-7.9c-1.6-2.7-3.7-5.8-3.7-5.8s-5.9,1.6-7.5,0.5s-5.3,4.3-9.5,0
	c-1.4-1.4-1.9-1.9-1.8-2c0,0.1,0.5,0.6,1.8,2c4.2,4.2,7.9-1.1,9.5,0s7.5-0.5,7.5-0.5s2.1,3.2,3.7,5.8c0.3,0.5,1.8,3.4,4,7.9
	c10.5-13.2,22.2-25.5,34.7-36.7c0.6-0.5,1.2-1,1.7-1.4s1-0.8,1.5-1.1c10.9-7.5,30-23.9,31.1-31.6s3.2-36.9,6.1-43.8
	c1.7-4,3-8.2,4-12.4c0,0-6.6-10.4-7.7-12.7c-1.3-5.1-2.1-10.4-2.4-15.7c0-1.9-0.3-18,0-22.3s13.2-24.2,13.2-24.2s-2.4-2.6-5.8-6.4
	c-2.7-2.5-4.9-5.5-6.7-8.8l0,0c-0.8-1.6-1-3.3-0.7-5.1c2.6-7.8,7.1-14.7,13.2-20.2c3.8-2.9,16.1-10.5,24.4-18.4l0,0
	c-1-2.7-2.7-5.1-5-6.8c-3.7-2.1-4.3-19.1-7.4-19.1h-13.8c0,0-5.8,13.3-5.8,8v-22.3c-1.7-2.4-4.5-3.8-7.4-3.7c-5.3,0-18.6-1.1-20.2,0
	c-1.6,1-19.1-0.5-19.1-0.5c-0.3-2.7-0.3-5.3,0-8c1.1-3.1,1.8-6.3,2.1-9.6c0-3.2,1.7-7.4-2.4-11.1c-4.9-5-9.3-10.6-13-16.5
	c-2.7-4.9-4.5-10.3-5.3-15.9c0-3.7,3.1-13.8,0-19.7c-3.2-5.8-12.7-23.4-16-24.9c-3.2-1.6-15.4-7.4-19.6-4.8s-19.6,5.8-19.6,5.8
	L489,54.8c0,0-5-8-7.3-8s-38.5-5.9-38.5-5.9l-17-5.3c-4.3-1.3-8.8-2.2-13.3-2.7c-2.8,0.1-5.6,1.1-7.9,2.7c-5.2,1.5-10.6,2.4-16,2.7
	c-6.9,0-23.9-1.6-23.9-1.6l-19.8-2l0,0c-0.5,0.4-0.9,0.8-1.4,1.1c-0.9,0.7-1.7,1.4-2.4,1.9c-0.1,0.1-0.2,0.2-0.3,0.3
	c-0.5,0.4-1,0.8-1.5,1.2c-0.5,0.3-0.9,0.7-1.3,1c-0.8,0.6-1.5,1-2,1.3c-8.5,5.4-16.6,11.7-23.9,18.6c-3.1,3.7-6.4,15.4-6.4,17.5
	s2.1,5.4-2.6,8.5c-4.8,3.2-10.1,2.1-11.7,9s-1.1,11.2-2.7,16.4c-1.6,5.4,0,6.9-6.4,10.6c-3.9,2.3-8.3,3.6-12.7,4
	c1.1,2.4,1.9,9,2.9,12.7c1.1,3.7,5.6,14.1,0,22.9c-5.6,8.8-6.6,18-7.4,25.2c-0.8,7.1-3.4,17.8-4.8,19.4c-2.2,3.8-4.2,7.8-5.9,11.9
	c-0.2,0.8-2.6,5.3,5.1,4s9.1-3.4,13.8-3.4s15.9,0.5,18.3,1.8s5.3,1.3,6.7,5.9c1.3,4.5,8.7,25.2,8.7,25.2c3.6,5.8,5.9,12.3,6.8,19
	l0,0c0.2,1.6,0.2,3.3,0.1,4.9c-0.8,12.2,0.6,23.4-2.1,33.2c-2.6,9.8-6.9,16.2-8.5,17c-0.2,0.1-0.4,0.2-0.7,0.3
	c-0.5,0.2-1.1,0.5-1.8,0.9c-0.5,0.2-1,0.5-1.6,0.8c-0.3,0.2-0.6,0.3-0.9,0.5c10.4,0.1,28.2,0.3,30.8-0.1c3.7-0.5,35.6-1,48.3,3.2
	c12.7,4.3,28.7,13.3,34.5,15.4 M348.4,275.5L348.4,275.5c0-0.1,1.3-2.8,3.1-4.1C349.6,272.7,348.4,275.5,348.4,275.5z M358.2,270.6
	c2.2-0.6,4.8-1.6,7-1.4C363,269,360.4,270,358.2,270.6z M464.7,285v11.7c0,0.6-0.3,1-0.7,1.4c0.5-0.3,0.7-0.8,0.7-1.4V285
	c0-4-0.8-14.7,4.7-17.8C463.9,270.4,464.7,281,464.7,285z M493.8,262.7c-1,0.7-2,1.4-3.1,2C491.8,264.1,492.9,263.5,493.8,262.7
	c1-1,4.9-4.3,8.3-6.5C498.7,258.5,494.8,261.8,493.8,262.7z M503.2,255.7c-0.3,0.2-0.6,0.4-0.9,0.5
	C502.6,256,502.9,255.8,503.2,255.7z M515.1,256.9L515.1,256.9c0,0,0.1-0.2,0.6-0.4C515.2,256.8,515.1,256.9,515.1,256.9z
	 M570.9,265.4c-0.3,0.2-0.6,0.4-0.9,0.5C570.3,265.8,570.5,265.6,570.9,265.4c4.5-3,11.8-9.3,16.2-11.8
	C582.6,256.2,575.3,262.4,570.9,265.4z"/>
<path id="BR-SC" class="estado st1" d="M628.7,330.4c1.1,2.4,7.7,12.7,7.7,12.7c-0.9,4.3-2.2,8.4-4,12.4c-2.9,6.9-5.1,36.1-6.1,43.8
	c-1.1,7.7-20.2,24.1-31.1,31.6c-0.5,0.3-1,0.7-1.5,1.1c-0.6,0.4-1.1,0.9-1.7,1.4c-12.6,11.3-24.2,23.5-34.7,36.7
	c-2.2-4.5-3.7-7.4-4-7.9c-1.6-2.7-3.7-5.8-3.7-5.8s-5.9,1.6-7.5,0.5s-5.3,4.2-9.5,0s0,0,1.6-2.6c1.6-2.7,8-9,10.1-14.4
	c2.1-5.3,0-10.1,1.6-11.7s8.5-3.2,13.3-13.3c4.8-10.1-10.1-5.8-11.7-5.8c-1.6,0-21.8,2.7-28.2,2.7s-21.2-8-26-14.9
	s-45.1-37.2-46.2-40.3c-1.1-3.2-7.4-4.2-7.4-4.2s-21.2-3.7-27.1-5.9c-5.8-2.1-21.7-11.1-34.5-15.4s-44.6-3.7-48.3-3.2
	c-2.6,0.4-20.4,0.2-30.8,0.1c0.3-0.2,0.6-0.3,0.9-0.5c0.6-0.3,1.1-0.6,1.6-0.8c0.7-0.4,1.4-0.7,1.8-0.9c0.3-0.1,0.5-0.3,0.7-0.3
	c1.6-0.8,5.9-7.1,8.5-17c2.7-9.8,1.4-21,2.1-33.2c0.1-1.6,0.1-3.3-0.1-4.9c4.3-1.7,8.6-3.1,13.1-4.1c2.7,0,8.5-1,10.1,3.2
	s10.6,5.8,10.6,5.8s2.6-5.9,5.9-4.6c3.1,1.4,10.7-4.6,14.1,0s12.4,9.4,14,9.9s7.4-0.5,12.2,0c4.8,0.5,13.3-1.1,17.5,2.6
	c1.9,1.8,4.1,3.4,6.3,4.8c3.7-0.9,7.5-0.9,11.2,0c5.4,1.6,18.1,11.7,22.9,11.2c4.8-0.6,12.2,0.5,12.2-2.7V285
	c0-4.8-1.1-18.8,8.5-18.7c9.5,0.1,14.3,0,14.3,0c2.3-0.9,4.4-2.1,6.4-3.6c1.6-1.6,10.6-9,13.3-8.5c2.7,0.7,5.4,1.6,7.9,2.7
	c0,0,0.6-1.1,7.9-2.7c7.5-1.5,14.9-3.6,16.5-3.6s10.6,1.6,13.8,6.4c3.2,4.8,5.8,7.4,7.9,7.9s4.8,3.7,9.6,0.6
	c4.8-3.2,12.7-10.1,17-12.2c3.4-1.7,17.6-3.8,39.2,0c1.8,3.3,4,6.2,6.7,8.8c3.4,3.7,5.8,6.4,5.8,6.4s-13,19.9-13.2,24.2
	c-0.3,4.2,0,20.4,0,22.3C626.7,320,627.4,325.3,628.7,330.4z" (click)="irParaCatalogo('SC', 'SANTA CATARINA')">
    <title>
      Santa Catarina
    </title>
  </path>
<path id="BR-PR" class="estado st1" d="M664,209.5c-8.2,7.9-20.6,15.6-24.4,18.4c-6.1,5.5-10.7,12.4-13.2,20.2c-0.3,1.7-0.1,3.5,0.7,5.1
	c-21.6-3.8-35.8-1.7-39.2,0c-4.3,2.1-12.2,9-17,12.2c-4.8,3.1-7.5,0-9.6-0.6s-4.8-3.2-7.9-7.9c-3.2-4.8-12.2-6.4-13.8-6.4
	s-9,2.1-16.5,3.6c-7.4,1.6-7.9,2.7-7.9,2.7c-2.6-1.1-5.2-1.9-7.9-2.7c-2.7-0.6-11.7,6.9-13.3,8.5c-2,1.5-4.1,2.7-6.4,3.6
	c0,0-4.8,0.1-14.3,0c-9.6-0.1-8.5,13.9-8.5,18.7v11.7c0,3.2-7.5,2.1-12.2,2.7c-4.8,0.5-17.5-9.6-22.9-11.2c-3.7-0.9-7.5-0.9-11.2,0
	c-2.3-1.4-4.4-3-6.3-4.8c-4.2-3.7-12.7-2.1-17.5-2.6s-10.6,0.5-12.2,0s-10.6-5.3-14-9.9s-11,1.4-14.1,0c-3.2-1.4-5.9,4.6-5.9,4.6
	s-9-1.6-10.6-5.8s-7.4-3.2-10.1-3.2c-4.5,1-8.9,2.4-13.1,4.1c-0.9-6.7-3.2-13.2-6.8-19c0,0-7.4-20.7-8.7-25.2
	c-1.4-4.5-4.3-4.5-6.7-5.9c-2.4-1.3-13.6-1.8-18.3-1.8c-4.8,0-6.1,2.1-13.8,3.4c-7.7,1.3-5.3-3.2-5.1-4c1.7-4.1,3.6-8.1,5.9-11.9
	c1.3-1.6,4-12.2,4.8-19.4s1.9-16.5,7.4-25.2c5.6-8.8,1.1-19.1,0-22.9c-1.1-3.7-1.8-10.4-2.9-12.7c4.5-0.4,8.8-1.7,12.7-4
	c6.4-3.7,4.8-5.3,6.4-10.6c1.6-5.3,1.1-9.5,2.7-16.4s6.9-5.8,11.7-9c4.8-3.1,2.6-6.4,2.6-8.5s3.2-13.8,6.4-17.5
	c7.4-7,15.4-13.2,23.9-18.6c0.5-0.3,1.2-0.7,2-1.3c0.4-0.3,0.9-0.6,1.3-1c0.5-0.3,1-0.7,1.5-1.2c0.1-0.1,0.2-0.2,0.3-0.3
	c0.8-0.6,1.6-1.2,2.4-1.9c0.5-0.3,0.9-0.7,1.4-1.1l0,0l19.8,2c0,0,17,1.6,23.9,1.6c5.4-0.3,10.8-1.2,16-2.7c2.3-1.6,5.1-2.5,7.9-2.7
	c4.5,0.5,9,1.4,13.3,2.7l17,5.3c0,0,36.1,5.9,38.5,5.9s7.3,8,7.3,8l22.1,5.8c0,0,15.4-3.1,19.6-5.8s16.5,3.1,19.6,4.8
	c3.2,1.6,12.7,19.1,16,24.9c3.1,5.8,0,15.9,0,19.7c0.8,5.6,2.6,10.9,5.3,15.9c3.8,5.9,8.1,11.5,13,16.5c4.1,3.7,2.4,8,2.4,11.1
	c-0.3,3.3-1,6.5-2.1,9.6c-0.3,2.7-0.3,5.3,0,8c0,0,17.5,1.5,19.1,0.5c1.6-1.1,14.9,0,20.2,0c3-0.1,5.8,1.3,7.4,3.7v22.3
	c0,5.3,5.8-8,5.8-8h13.8c3.1,0,3.7,17,7.4,19.1C661.2,204.4,663,206.8,664,209.5L664,209.5z" (click)="irParaCatalogo('PR', 'PARANA')">
    <title>
      Paraná
    </title>
  </path>
<path id="BR-RS" class="estado st1" d="M545.9,428.4c-1.6,1.6,0.5,6.4-1.6,11.7s-8.5,11.7-10.1,14.4c-1.6,2.6-5.8-1.6-1.6,2.6
	c4.3,4.3,7.9-1.1,9.5,0s7.5-0.5,7.5-0.5s2.1,3.1,3.7,5.8c0.3,0.5,1.8,3.4,4,7.9c-1.7,2.1-3.4,4.3-4.9,6.3c-0.6,0.8-1.2,1.6-1.7,2.4
	c-3,3.9-5.6,8-7.9,12.4c-8.8,17.2-44,80.7-48.6,88.4c-4.5,7.7-31.3,30-43,36.4c-8.5,4.4-16.7,9.4-24.4,14.9
	c-7.1,5.4-9.1,15.1-16.7,21c-4.3,2.8-8.4,5.9-12.3,9.2c-6.4,6.5-8.5,16-11.4,24.6c-4,11.7-9.3,26.4-18,35.5
	c-3.6,3.6-8.4,4.4-12.4,7.6c-6.3,4.9-17.8,21.5-26.7,18.9c-9-2.6-7.3-14.1-8.2-21c-1.3-10.1,0-11.9,2.7-18c2.6-6.1,7.9-5.8,10.1-8.5
	s9-6.6,12.2-11.2c3.2-4.5-3.2-10.9-5.9-14.1c-2.6-3.2-12.2-4.3-16.4-6.4c-4.5-2.9-7.4-7.9-7.7-13.3c0-4.5-6.4-10.4-11.7-15.7
	c-5.3-5.3-11.4-11.1-11.4-11.1s-14.9-3.7-22.3-13.5s-7.7-8.5-10.1-9.6s-13.3-4.3-19.1-9.6s-6.6-2.7-16.2-6.9
	c-9.6-4.3-9-4.2-17.5-12.5c-8.5-8.2-11.7-13.8-16.7-17c-5.1-3.1-5.9,3.5-7.2,9.8c-1.3,6.4-11.7,6.9-14.3,3.7s-3.7-10.6-7.2-16.2
	c-3.4-5.6-17-19.6-21.8-26.6c-4.8-6.9-15.4-11.2-24.7-15.9c-9.3-4.8-14.9,1.1-17.5,4s-18.6,7.4-22.8,5c-4.2-2.4-3.2-4,0.3-8.8
	c3.4-4.8,34-39.5,43-48.3s35.6-40.1,40.1-43.8c4.5-3.7,10.9-11.2,14.9-14.6c4-3.5,9.3,0.3,11.7-2.7c2.4-2.9-6.4-1.8,3.2-10.6
	c9.5-8.8,24.1-18.6,40.3-30c10.1-7.2,20.8-13.7,31.9-19.4c2.1-1.1,20.4-4.8,25.5-9.3c3.5-2.8,7.4-5.3,11.5-7.3l1.3-0.6
	c10.4,0.1,28.2,0.3,30.8-0.1c3.7-0.5,35.6-1,48.3,3.2s28.7,13.3,34.5,15.4c5.9,2.1,27.1,5.9,27.1,5.9s6.4,1,7.4,4.2
	c1.1,3.1,41.4,33.4,46.2,40.3c4.8,6.9,19.7,14.9,26,14.9c6.4,0,26.5-2.7,28.2-2.7c1.6,0,16.4-4.2,11.7,5.8
	C554.4,425.2,547.5,426.8,545.9,428.4z" (click)="irParaCatalogo('RS', 'RIO GRANDE DO SUL')">
    <title>
      Rio Grande do Sul
    </title>
  </path>
  <g id="Paraná">
    <g id="Elipse_00000021120356865216652820000012493645010284299405_" transform="translate(719 3996)">
      <ellipse transform="matrix(0.9816 -0.1907 0.1907 0.9816 721.8813 -124.1144)" class="st2" cx="-283.9" cy="-3812.4" rx="29.7" ry="29.7"/>
      <g>
        <g>
          <ellipse transform="matrix(0.9993 -3.837649e-02 3.837649e-02 0.9993 146.0972 -13.7112)" class="st3" cx="-284.1" cy="-3812.4" rx="29.2" ry="29.2"/>
        </g>
      </g>
    </g>
    @if (qtdProjetosPR !== '01') {
      <text transform="matrix(1 0 0 1 414.443 198.8865)" class="st4 st5 st6 label-projetos">PROJETOS</text>
    }
    @if (qtdProjetosPR === '01') {
      <text transform="matrix(1 0 0 1 414.443 198.8865)" class="st4 st5 st6 label-projetos">PROJETO</text>
    }
    <text transform="matrix(1 0 0 1 421.1647 185.8885)" class="st4 st7 st8 contador-projetos" [innerHTML]="qtdProjetosPR"></text>
    <text transform="matrix(1 0 0 1 397.3381 142.8338)" class="st4 st7 st9 nome-estado">Paraná</text>
  </g>
  <g id="Santa_Catarina">
    <g id="Elipse_00000026849147356648375750000017954541581123601281_" transform="translate(719 3996)">
      <circle class="st2" cx="-191.7" cy="-3627.3" r="29.7"/>
      <g>
        <g>
          <circle class="st3" cx="-191.6" cy="-3627.2" r="29.2"/>
        </g>
      </g>
    </g>
    @if (qtdProjetosSC !== '01') {
      <text transform="matrix(1 0 0 1 506.7791 383.7397)" class="st4 st5 st6 label-projetos">PROJETOS</text>
    }
    @if (qtdProjetosSC === '01') {
      <text transform="matrix(1 0 0 1 506.7791 383.7397)" class="st4 st5 st6 label-projetos">PROJETO</text>
    }
    <text transform="matrix(1.0518 0 0 1 513.501 369.5565)" class="st4 st7 st10 contador-projetos" [innerHTML]="qtdProjetosSC"></text>
    <text transform="matrix(1 0 0 1 449.3552 327.687)" class="st4 st7 st9 nome-estado">Santa Catarina</text>
  </g>
  <g id="Rio_Grande_do_Sul">
    <g id="Elipse_00000026852950557455026110000012191977114838703518_" transform="translate(719 3996)">
      <circle class="st2" cx="-372.4" cy="-3480.8" r="29.7"/>
      <g>
        <g>
          <circle class="st3" cx="-372.5" cy="-3480.7" r="29.2"/>
        </g>
      </g>
    </g>
    @if (qtdProjetosRS !== '01') {
      <text transform="matrix(1 0 0 1 326.141 530.2681)" class="st4 st5 st6 label-projetos">PROJETOS</text>
    }
    @if (qtdProjetosRS === '1') {
      <text transform="matrix(1 0 0 1 326.141 530.2681)" class="st4 st5 st6 label-projetos">PROJETO</text>
    }
    <text transform="matrix(1 0 0 1 332.8626 517.2701)" class="st4 st7 st8 contador-projetos" [innerHTML]="qtdProjetosRS"></text>
    <text transform="matrix(1 0 0 1 254.4331 474.2154)" class="st4 st7 st9 nome-estado">Rio Grande do Sul</text>
  </g>
</svg>
